import qweBaseField from "../BaseField"
import dayjs from "../../../utils/dayjs"

export default {
    mixins:[qweBaseField],
    data: function () {
        return {
            type: ""
        };
    },

    created: function () {
        this.type = this.selfSetting.DisplayTypeValue === 0 ? "date" : "datetime";
    },

    computed:{
        valueString: function () {
            if (this.data[this.name] == null) {
                return null;
            }
            if (this.type == "date") {
                return dayjs(this.data[this.name]).format("YYYY-MM-DD");
            }
            else {
                return dayjs(this.data[this.name]).format("YYYY-MM-DDTHH:mm:ss.SSS");
            }
        }
    },

    methods: {
        setValueBeforeHook: function (Value) {
            let result = new Date(Value);
            return result == "Invalid Date" ? null : result;
        }
    }
}